module.exports = __webpack_public_path__ + "img/share_logo.cca31de2.png";